import { createApp } from 'vue'
import router from './router'

import './style.css'
import App from './App.vue'

// Import Flowbite's JavaScript
import 'flowbite';

const app = createApp(App)
app.use(router)
app.mount('#app')

document.addEventListener('DOMContentLoaded', () => {
    document.body.classList.add('loaded')
})